import { z } from 'zod';

/**
 * Search di `/impersonate`: il backoffice manda il token di passaggio e il
 * tenant. Al boot `captureImpersonationHandoffToken` toglie il token
 * dall'indirizzo (e lo tiene in memoria), quindi qui è facoltativo: resta solo
 * per una navigazione interna che lo porti ancora. Il refresh token dei link
 * vecchi si scarta.
 */
export const impersonateSearchSchema = z.object({
  token: z.string().optional(),
  tenant: z.string(),
});
